function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Modal from './modal';
/**
 * @module Alert
 * @since  0.8.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Alert = /*#__PURE__*/function (_Modal) {
  _inherits(Alert, _Modal);

  var _super = _createSuper(Alert);

  /**
   * Plugin constructor
   * @param  {Object} options The options object for this plugin
   * @return {this} The newly created plugin instance
   */
  function Alert(options) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, options);

    _this.element.classList.add('alert');

    _this.open();

    return _this;
  }
  /**
   * Create the alerts structure
   * @returns {void}
   */


  _createClass(Alert, [{
    key: "createCardStructure",
    value: function createCardStructure() {
      if (this.option('showHeader')) {
        /** @param {HTMLElement} */
        this.header = Bulma.findOrCreateElement('.modal-card-head', this.content, 'header', ['modal-card-head', 'has-background-' + this.option('type')]);
        /** @param {HTMLElement} */

        var textColor = this.option('type') == 'warning' ? 'black' : 'white';
        this.headerTitle = Bulma.createElement('p', ['modal-card-title', 'has-text-' + textColor]);
        this.headerTitle.innerHTML = this.title;
        this.header.appendChild(this.headerTitle);
      }
      /** @param {HTMLElement} */


      this.cardBody = Bulma.findOrCreateElement('.modal-card-body', this.content, 'section');

      if (!this.cardBody.innerHTML) {
        this.cardBody.innerHTML = this.body;
      }
      /** @param {HTMLElement} */


      this.footer = Bulma.findOrCreateElement('.modal-card-foot', this.content, 'footer');
    }
    /**
     * Go through the provided buttons option and create the buttons.
     * @returns {void}
     */

  }, {
    key: "createButtons",
    value: function createButtons() {
      var _this2 = this;

      var defaultButtonOptions = {
        close: true,
        destroy: true,
        onClick: function onClick(e) {}
      };
      var confirmOptions = this.option('confirm');

      if (typeof confirmOptions === 'string') {
        confirmOptions = {
          label: confirmOptions,
          classes: []
        };
      }

      confirmOptions = _objectSpread(_objectSpread({}, defaultButtonOptions), confirmOptions);
      var confirmButton = Bulma.createElement('button', ['button', 'is-' + this.option('type')].concat(confirmOptions.classes));
      confirmButton.innerHTML = confirmOptions.label;
      confirmButton.addEventListener('click', function (e) {
        confirmOptions.onClick(e);

        if (confirmOptions.close) {
          _this2.close();
        }

        if (confirmOptions.destory) {
          _this2.destroy();
        }
      });
      this.footer.appendChild(confirmButton);

      if (this.option('cancel')) {
        var cancelOptions = this.option('cancel');

        if (typeof cancelOptions === 'string') {
          cancelOptions = {
            label: cancelOptions,
            classes: []
          };
        }

        cancelOptions = _objectSpread(_objectSpread({}, defaultButtonOptions), cancelOptions);
        var cancelButton = Bulma.createElement('button', ['button'].concat(cancelOptions.classes));
        cancelButton.innerHTML = cancelOptions.label;
        cancelButton.addEventListener('click', function (e) {
          cancelOptions.onClick(e);

          if (cancelOptions.close) {
            _this2.close();
          }

          if (cancelOptions.destroy) {
            _this2.destroy();
          }
        });
        this.footer.appendChild(cancelButton);
      }
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options THe options object for the new instance
     * @return {Alert} The newly created instance
     */
    function create(options) {
      return new Alert(options);
    }
    /**
     * Get the root class this plugin is responsible for.
     * This element has no HTML only equivelent. So this is not required.
     * @returns {string} The class this plugin is responsible for.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return '';
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        type: 'info',
        title: '',
        body: '',
        confirm: 'Okay',
        cancel: null,
        style: 'card',
        parent: document.body,
        showHeader: true
      };
    }
  }]);

  return Alert;
}(Modal);

Bulma.registerPlugin('alert', Alert);
export default Alert;